import React from 'react'
import MainHeader from "./partials/newheader";    
import About from './About';
import Footer from "./partials/footer";

export default function Pettipettiabout() {
  return (
    <div>
      <MainHeader />
      <About />
      <Footer />
    </div>
  );
}
